import {
  Card,
  CardContent,
  CardMedia,
  Grid,
  Typography,
} from '@material-ui/core';

export type Video = {
  title: string;
  src: string;
};

export const VideoGrid = ({ videos }: { videos: Video[] }) => (
  <Grid container spacing={3} direction="row">
    {videos.map(video => (
      <Grid key={video.title} item sm={12} md={6} lg={4}>
        <Card>
          <CardMedia>
            <iframe
              src={video.src}
              title={video.title}
              allowFullScreen
              width="100%"
            />
          </CardMedia>
          <CardContent>
            <Typography gutterBottom variant="h5" component="div">
              {video.title}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    ))}
  </Grid>
);
